import { useState, useEffect } from 'react';
import fileApi from '../services/file.service';

/**
 * Hook to resolve a contact avatar URL from an avatarFileId.
 * Fetches a presigned download URL from the file service.
 */
export function useContactAvatarUrl(avatarFileId?: number | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!avatarFileId) {
      setUrl(null);
      return;
    }

    let cancelled = false;

    fileApi
      .getDownloadUrl(avatarFileId)
      .then((downloadUrl) => {
        if (!cancelled) setUrl(downloadUrl);
      })
      .catch((err) => {
        console.error('Failed to fetch contact avatar URL:', err);
        if (!cancelled) setUrl(null);
      });

    return () => {
      cancelled = true;
    };
  }, [avatarFileId]);

  return url;
}
